import Waiting from '@/store/waiting';

export default class SendgridEventActions {
  constructor (Api, types) {
    const actions = {
      async getSendgridEventsAction ({ commit }, args) {
        await waiting.check('getSendgridEventsAction', async () => {
          try {
            const res = await Api.getSendgridEvents(args);
            commit(types.SET_SENDGRID_EVENTS, Object.values(res.data)[0]);
          } catch (err) {
            throw err;
          }
        });
      },
    };
    const waiting = new Waiting(actions);
    this.actions = actions;
  }
}
